<template>
	<v-dialog v-model="dialog" max-width="500px" hide-overlay>
		<template v-slot:activator="{ on }">
			<v-btn color="#1A237E" class="text-lowercase" icon v-on="on">
				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<v-icon small v-on="on">mdi-lead-pencil</v-icon>
					</template>
					<span>edit franchise</span>
				</v-tooltip>
			</v-btn>
		</template>
		<v-card v-if="!loading">
			<v-card-title class="pt-6">
				<span class="subtitle-1">
					Parameters of <span class="accentColor">{{ chan.name }}</span>
				</span>
			</v-card-title>
			<v-card-text class="black--text">
				<v-container grid-list>
					<v-form v-model="valid" ref="form" validation>
						<v-row>
							<v-col cols="12" sm="6" md="4">
								<v-text-field
									color="#1A237E"
									label="Franchise cost"
									v-model.number="franchiseCost"
									name="franchiseCost"
									type="text"
									:rules="numberRules"
									@change="onceMore">
								</v-text-field>
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-text-field
									color="#1A237E"
									label="Franchise fee"
									v-model.number="franchiseFee"
									name="franchiseFee"
									type="text"
									:rules="numberRules"
									@change="onceMore">
								</v-text-field>
							</v-col>
						</v-row>
					</v-form>
				</v-container>
				<v-row justify="center" class="error mx-2">{{ error }}</v-row>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="#1A237E" text
					class="text-capitalize" 
					@click="closeDialog">
					Decline
				</v-btn>
				<v-btn color="#1A237E" text
					class="text-capitalize"
					:disabled="loading || Boolean(error)"
					@click="changeChannel">
					Confirm
				</v-btn>
			</v-card-actions>
		</v-card>	
		<div v-else class="text-center">
			<loader></loader>
		</div>
	</v-dialog>
</template>

<script>
import Loader from '../../layouts/Loader.vue'

	export default {
		props: ['chan', 'gameId', 'round'],
		data () {
			return	{
				dialog: false,
				valid: false,
				error: '',
				franchiseCost: this.chan.franchiseCost,
				franchiseFee: this.chan.franchiseFee,
				numberRules: [
					v => !!v || 'this field is required',
					v => /^[+]?[1-9]/.test(v) || 'it\'s expected number'
				]
			}
		},
		computed: {
			loading () {
				return this.$store.getters.loading
			}
		},
		methods: {
			onceMore () {
				this.error = ''
			},
			async changeChannel () {

				if (this.$refs.form.validate()) {
					
					if (this.chan.franchiseCost === this.franchiseCost ||
						this.chan.franchiseFee === this.franchiseFee) {
						this.error = 'You didn\'t change any params of franchise'
					}
					else {
						
						this.chan.franchiseCost =  this.franchiseCost
						this.chan.franchiseFee = this.franchiseFee

						try {
							//changeChannel 
							await this.$store.dispatch('changeChannel', {
								gameId: this.gameId,
								round: this.round,
								channel: this.chan
							})
							this.closeDialog ()					
						}
						catch (error) {
							this.error = error.message
						}
					}
				}
				else {
					this.error = 'Enter all params correctly, please'
				}
			},
			closeDialog () {
				//reset
				this.dialog = false
				this.error = ''
			}
		},
		components: {Loader}
	}
</script>
<style>
	.error{
		color: white
	}
</style>